(function () {
  function log(...args) {
    console.log('[Province Filter]', ...args);
  }

  function getConfig() {
    return (window.theme && window.theme.provinceFiltering) || {};
  }

  function isEnabled() {
    const config = getConfig();
    return Boolean(config.enabled);
  }

  function isOntarioVisitor() {
    return document.body.dataset.province === 'ON';
  }

  function applyProvinceNav() {
    const provinceMenus = document.querySelectorAll('main-menu[data-province-menu]');
    if (!provinceMenus.length) {
      log('applyProvinceNav: no province menus found');
      return;
    }

    const isMobile = !window.matchMedia('(min-width: 750px)').matches;
    const wasMenuOpen = isMobile && document.body.classList.contains('main-menu-open');

    if (wasMenuOpen) {
      window.location.reload();
      return;
    }

    const activeMenu = isOntarioVisitor() ? 'ontario' : 'other';
    log('applyProvinceNav: province=', document.body.dataset.province, '→ menu=', activeMenu);
    provinceMenus.forEach((menu) => {
      const isActive = menu.dataset.provinceMenu === activeMenu;
      menu.style.display = isActive ? '' : 'none';
      menu.setAttribute('aria-hidden', String(!isActive));
    });
  }

  function applyProvinceSections() {
    const sections = document.querySelectorAll('[data-province-section]');
    if (!sections.length) return;

    const province = document.body.dataset.province;
    const isNonCanada = !province;
    const activeProvince = isNonCanada ? 'non_canada' : (isOntarioVisitor() ? 'ontario' : 'other');
    log('applyProvinceSections: province=', province, '→ showing sections for', activeProvince);
    sections.forEach((el) => {
      const sectionVisibility = el.dataset.provinceSection;
      const shouldShow = sectionVisibility === activeProvince;
      const wrapper = el.closest('.shopify-section') || el;
      wrapper.style.display = shouldShow ? '' : 'none';
      log('  section', wrapper.id || '?', 'visibility=', sectionVisibility, 'show=', shouldShow);
    });
  }

  function applyCollectionTagFilter() {
    const facetFilters = document.querySelector('facet-filters');
    if (!facetFilters) return;

    const tagValue = isOntarioVisitor() ? 'PROV' : 'FED';
    log('applyCollectionTagFilter: auto-applying tag', tagValue);
    const form = facetFilters.querySelector('form') || document;

    // Uncheck all existing tag filters first (avoid double tags when province changes).
    // const allTagInputs = form.querySelectorAll('input[name*="tag"]');
    const allTagInputs = form.querySelectorAll('input[name*="filter.p.m.custom.supported_provinces"]');
    allTagInputs.forEach((input) => {
      input.checked = false;
    });

    // let tagCheckbox = form.querySelector(`input[name="filter.p.tag"][value="${tagValue}"]`);
    // if (!tagCheckbox) {
    //   tagCheckbox = form.querySelector(`input[value="${tagValue}"]`);
    // }

    // if (!tagCheckbox) {
    //   log('applyCollectionTagFilter: no tag checkbox for', tagValue, '→ show banner');
    //   updateCollectionBanner(0);
    //   return;
    // }

    // tagCheckbox.checked = true;
    // tagCheckbox.dispatchEvent(new Event('input', { bubbles: true }));
    let provincesCheckbox = form.querySelector(`input[name="filter.p.m.custom.supported_provinces"][value="${tagValue}"]`);
    // if (!provincesCheckbox) {
    //   provincesCheckbox = form.querySelector(`input[value="${tagValue}"]`);
    // }

    if (!provincesCheckbox) {
      log('applyCollectionTagFilter: no provinces checkbox for', tagValue, '→ show banner');
      updateCollectionBanner(0);
      return;
    }

    log('applyCollectionTagFilter: provinces checkbox found for', tagValue);
    provincesCheckbox.checked = true;
    provincesCheckbox.dispatchEvent(new Event('input', { bubbles: true }));
    updateCollectionBanner();
  }

  function updateCollectionBanner(productCount) {
    const banner = document.querySelector('.js-province-banner');
    if (!banner) return;

    const resultsEl = document.getElementById('filter-results');
    const productsGrid = resultsEl && resultsEl.querySelector('ul');
    const paginationNav = resultsEl && resultsEl.querySelector('nav');
    const pageFilters = document.querySelector('.main-products-grid__filters');
    const countBadge = document.querySelector('.collection-banner__count');

    const noResults = productCount === 0;

    if (noResults) {
      const config = getConfig();
      const fallbackHandle = isOntarioVisitor()
        ? config.ontarioFallbackCollectionURL
        : config.nonOntarioFallbackCollectionURL;

      const link = banner.querySelector('.js-province-banner-link');
      if (link && fallbackHandle) {
        link.href = fallbackHandle;
      } else if (link) {
        link.hidden = true;
      }
    }

    banner.hidden = !noResults;
    if (productsGrid) productsGrid.hidden = noResults;
    if (paginationNav) paginationNav.hidden = noResults;
    if (countBadge) countBadge.hidden = noResults;
    if (pageFilters) pageFilters.hidden = noResults;
  }

  function checkProductPageAccess() {
    const config = getConfig();
    const productTags = config.productTags;

    if (!Array.isArray(productTags)) return;

    const requiredTag = isOntarioVisitor() ? 'PROV' : 'FED';
    const hasTag = productTags.some(
      (tag) => String(tag).toUpperCase() === requiredTag
    );

    log('checkProductPageAccess: requiredTag=', requiredTag, 'productTags=', productTags, 'hasTag=', hasTag);
    if (!hasTag) {
      log('checkProductPageAccess: redirecting to homepage (product ineligible)');
      window.location.replace(window.theme.routes.root);
    }
  }

  function runProvinceFilter() {
    if (!isEnabled()) {
      log('runProvinceFilter: disabled');
      return;
    }

    log('runProvinceFilter: province=', document.body.dataset.province || '(none / non-Canada)');
    applyProvinceSections();

    if (!document.body.dataset.province) {
      log('runProvinceFilter: no province set, skipping nav/tag/product redirect');
      return;
    }

    applyProvinceNav();
    applyCollectionTagFilter();
    checkProductPageAccess();
  }

  function clearProvinceTagFiltersWhenNotCanada() {
    const country = (window.theme && window.theme.localizationCountry) || '';
    if (String(country).toUpperCase() === 'CA') return;

    const template = (document.body && document.body.dataset.template) || '';
    if (template !== 'search' && template !== 'collection') return;

    const url = new URL(window.location.href);
    // const tagParam = url.searchParams.get('filter.p.tag');
    // if (tagParam !== 'PROV' && tagParam !== 'FED') return;

    // url.searchParams.delete('filter.p.tag');

    const provincesParam = url.searchParams.get('filter.p.m.custom.supported_provinces');
    if (provincesParam !== 'PROV' && provincesParam !== 'FED') return;

    url.searchParams.delete('filter.p.m.custom.supported_provinces');

    const cleanUrl = url.pathname + (url.search || '') || url.pathname;
    log('clearProvinceTagFiltersWhenNotCanada: redirecting to', cleanUrl);
    window.location.replace(cleanUrl);
  }

  document.addEventListener('on:province:detected', runProvinceFilter);

  document.addEventListener('on:collection:filtered', function (evt) {
    if (!isEnabled()) return;
    applyCollectionTagFilter();
  });

  document.addEventListener('DOMContentLoaded', function () {
    clearProvinceTagFiltersWhenNotCanada();
    applyProvinceNav();
    applyProvinceSections();
    runProvinceFilter();
  });
})();
